import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initSliderKeyFigures() {
  const swiper = new Swiper('.o-key-figures__slider', {
    loop: true,
    spaceBetween: 56,
    slidesPerView: 2,
    modules: [Navigation],
    navigation: {
      nextEl: '.o-key-figures__next',
      prevEl: '.o-key-figures__prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
}
